import React from "react";
import { useRouter } from "next/router";
export const RenderBesides = (param)=>{
    let { routes , children  } = param;
    const router = useRouter();
    if (routes.includes(router.pathname)) return null;
    return children;
};
